if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          if (event.target.closest('.modal-nav-btn--prev')) {
            event.preventDefault();
            this.navigateMedia(-1);
          } else if (event.target.closest('.modal-nav-btn--next')) {
            event.preventDefault();
            this.navigateMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll('.product-media-modal__content img').forEach((element) => {
          element.classList.remove('active');
          element.style.display = 'block';
        });
        
        const activeMedia = this.querySelector(`.product-media-modal__content img[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        activeMedia.classList.add('active');
        
        setTimeout(() => {
          activeMedia.scrollIntoView({
            behavior: 'auto',
            block: 'nearest',
            inline: 'center'
          });
        }, 50);
      }

      navigateMedia(direction) {
        const elements = Array.from(this.querySelectorAll('.product-media-modal__content img'));
        if (!elements.length) return;

        let activeIndex = elements.findIndex(el => el.classList.contains('active'));
        if (activeIndex === -1) activeIndex = 0;

        let newIndex = activeIndex + direction;
        if (newIndex >= elements.length) newIndex = 0; 
        if (newIndex < 0) newIndex = elements.length - 1; 

        elements.forEach(el => el.classList.remove('active'));
        elements[newIndex].classList.add('active');
        
        elements[newIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  );
}